module.exports = __webpack_public_path__ + "static/media/eng-sci.4d6259ed.jpg";